export default "__VITE_PUBLIC_ASSET__ede8ce74__"